'use client'

import type React from 'react'
import { useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { ReturnOrder } from '@/components/molecules'

interface ReturnOrderModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const ReturnOrderModal = ({ open }: ReturnOrderModalProps) => {
  const { closeModal } = useModals()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('RETURN_ORDER')}
        size="lg"
        className="w-full max-w-[340px] md:max-w-[500px] lg:max-w-[900px]"
      >
        <DialogHeader>
          <DialogTitle>
            <div className="flex items-center gap-2">Return Order</div>
          </DialogTitle>
          <DialogDescription className="text-left">
            Enter order number to return order
          </DialogDescription>
        </DialogHeader>

        {open && (
          <div className="flex h-full w-full flex-col">
            <ReturnOrder />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
